import { SETTINGS_VERSION, type PersistedSettingsEnvelope, type StoredSettings } from './types.js'

const STORAGE_KEY = 'se:settings'

export function loadSettingsFromStorage(): {
	values: StoredSettings
	activePreset: string | null
} {
	if (typeof localStorage === 'undefined') {
		return { values: {}, activePreset: null }
	}

	const raw = localStorage.getItem(STORAGE_KEY)
	if (!raw) return { values: {}, activePreset: null }

	try {
		const envelope: PersistedSettingsEnvelope = JSON.parse(raw)
		if (envelope.version === SETTINGS_VERSION) {
			return {
				values: envelope.values ?? {},
				activePreset: envelope.activePreset ?? null
			}
		}
	} catch {
		// Corrupt data — start fresh
	}

	return { values: {}, activePreset: null }
}

export function persistSettingsToStorage(
	values: StoredSettings,
	activePreset: string | null
): void {
	if (typeof localStorage === 'undefined') return

	const envelope: PersistedSettingsEnvelope = {
		version: SETTINGS_VERSION,
		lastModified: new Date().toISOString(),
		activePreset,
		values
	}

	localStorage.setItem(STORAGE_KEY, JSON.stringify(envelope))
}

export function buildExportEnvelope(
	values: StoredSettings,
	activePreset: string | null
): PersistedSettingsEnvelope {
	return {
		version: SETTINGS_VERSION,
		lastModified: new Date().toISOString(),
		activePreset,
		values
	}
}
